import { render, staticRenderFns } from "./AddLeave.vue?vue&type=template&id=201591ca&scoped=true&"
import script from "./AddLeave.vue?vue&type=script&lang=js&"
export * from "./AddLeave.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./AddLeave.vue?vue&type=style&index=1&id=201591ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201591ca",
  null
  
)

export default component.exports